<div class="main-wrap">
  <div class="add-new-box">
    <p-button label="New Promotion" routerLink="/management/promotion-create"></p-button>
  </div>

<div class="table-wrap">
  <div class="top-bar">
    <p-selectButton [options]="displayOptions" [(ngModel)]="selectedDisplayOption" (onChange)="updateView()"></p-selectButton>
  </div>
  <p-table selectionMode="single" [value]="promotions">
    <ng-template pTemplate="header">
      <tr>
        <th>
          ID
        </th>
        <th>
          From
        </th>
        <th>
          To
        </th>
        <th>
          Programme
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-promotion>
      <tr [pSelectableRow]="promotion" routerLink="/management/promotion-edit/{{promotion.id}}">
        <td>
          {{promotion.id}}
        </td>
        <td>
          {{promotion.start | date: 'dd/MM/yyyy'}}
        </td>
        <td>
          {{promotion.end | date: 'dd/MM/yyyy'}}
        </td>
        <td>
          {{promotion.studyProgram.name | titlecase}}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
</div>